export default class AttachWorkerBuilder extends Worker {
  constructor() {
    const workerScript = `
    self.onmessage = async function (e) {
      const { UPLOAD_AUDITED_CHART, token, formDataObject } = e.data;
      const file = formDataObject.upload_audited_chart;
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ];
      if (!file) {
        postMessage({ success: false, error: 'No file provided.' });
        return;
      }
      if (!allowedTypes.includes(file.type) && !file.name.match(/\\.(xlsx|xls)$/i)) {
        postMessage({ success: false, error: 'Unsupported file type. Please upload an Excel file (.xlsx or .xls).' });
        return;
      }
      const formData = new FormData();
      formData.append("upload_audited_chart", file);
      formData.append("chart_id", formDataObject.chart_id);
      try {
        const response = await fetch(UPLOAD_AUDITED_CHART, {
          method: 'PATCH',
          body: formData,
          headers: {
            Authorization: token,
          },
        });
        if (!response.ok) {
          const errData = await response.json().catch(() => null);
          const errMsg = errData?.message || errData?.detail || 'Failed to upload file. Please try again.';
          postMessage({ success: false, error: errMsg });
          return;
        }
        const data = await response.json();
        postMessage({ success: true, data });
      } catch (error) {
        postMessage({ success: false, error: error.message || 'Network error. Please check your connection.' });
      }
    };
    `;
    const blob = new Blob([workerScript], { type: 'application/javascript' });
    return new Worker(URL.createObjectURL(blob));
  }
}